import React, { Component } from "react";
import FlatButton from "material-ui/FlatButton";
import ActionDownload from "material-ui/svg-icons/file/cloud-download";
import Snackbar from "material-ui/Snackbar";

import { pink400 } from "material-ui/styles/colors";
const contentCSV =
  "Email,First Name,Last Name,Nickname,Mobile,Margin,Instagram,Youtube\nar@gmail.com, Agus, Ringgo, ar, 08123456789, 1, ar, ar";
class DownloadTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      autoHideDuration: 4000,
      message: "Please try again",
      open: false
    };
  }
  handleRequestClose = () => {
    this.setState({
      open: false
    });
  };

  downloadFile = () => {
    let blob = new Blob([contentCSV], { type: "text/csv" });
    let url = URL.createObjectURL(blob);
    let link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "import_agency_marketer.csv");
    document.body.appendChild(link);
    link.click();
  };

  render() {
    const { open, message, autoHideDuration } = this.state;
    return (
      <div>
        <FlatButton
          icon={<ActionDownload />}
          label="Template"
          onClick={this.downloadFile.bind(this)}
          primary={true}
        />
        <Snackbar
          open={open}
          bodyStyle={{ backgroundColor: pink400 }}
          message={message}
          autoHideDuration={autoHideDuration}
          onRequestClose={this.handleRequestClose}
        />
      </div>
    );
  }
}

export default DownloadTemplate;



// WEBPACK FOOTER //
// ./src/agency/DownloadTemplate.js